import React, { useState } from 'react'
import {LogOut, Search} from "lucide-react"
import { toast } from 'react-toastify';
import CustomLoader from '../Loader';

function PageHeader({newData, setDisabled}) {
  const [isLoading, setIsLoading]= useState(false);

  async function updateFields() {
    try {
      setDisabled(true);
      setIsLoading(true);
      const linearData = newData.flat();
      console.log("-----");
      console.log(linearData);
      const res = await fetch("/server/fodder_portal_access_free_function/batches", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: linearData
        })
      })
      const response = await res.json();
      console.log(response);
      toast.success("Your fields updated successfully");
    } catch (error) {
      toast.error(error.message);
    }
    finally {
      setIsLoading(false);
      setDisabled(false);
    }
  }

  return (
    <header className="sticky top-0 z-30 flex min-h-16 items-center justify-between gap-4 border-b bg-white">
        <div className="flex items-center justify-between w-full">
          <h1 className=" md:text-xl font-semibold">Batches Dashboard</h1>
          <span className='flex items-center space-x-3'>
            {/* <LogOut 
              className='cursor-pointer hover:text-blue-500 h-6'
              onClick={()=>{
                sessionStorage.removeItem("vendorId");
                sessionStorage.removeItem("vendorPin");
                window.location.href="/";
              }}
            /> */}
            <button 
              className=" bg-blue-500 hover:bg-blue-700 text-white text-medium font-light md:font-bold py-1 px-3 md:py-2 md:px-4 rounded w-fit "
              onClick={()=>{updateFields()}}
              disabled={isLoading}
            >
              {
                isLoading ? <CustomLoader size={4} color="#000000"/> : "Save"
              }
            </button>
          </span>
        </div>
    </header>
  )
}

export default PageHeader